import { useTranslation } from "react-i18next";
import { FaChevronLeft } from "react-icons/fa6";
import Button from "../../../components/buttons/button";
import { useFormik } from "formik";
import TextInput from "../../../components/inputs/textInput";
import Select from "../../../components/select/select";
import { useOptions } from "../../../components/hooks/useOptionsHook";
import DateInput from "../../../components/inputs/dateInput";
import TimeInput from "../../../components/inputs/timeInput";
import TextArea from "../../../components/inputs/textArea";
import FileInput from "./FileInput";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";

const EditActivity = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const validationSchema = yup.object({
    name: yup.string().required(t("required")),
    category: yup.string().required(t("required")),
    allowedCategory: yup.string().required(t("required")),
    startDate: yup.string().required(t("required")),
    time: yup.string().required(t("required")),
    maxSeats: yup.number().required(t("required")),
    desc: yup.string().required(t("required")),
  });
  const formik = useFormik({
    initialValues: {
      name: "",
      category: "",
      allowedCategory: "",
      startDate: "",
      time: "",
      maxSeats: "",
      desc: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
    },
  });
  const { memberShipTypeOptions } = useOptions();
  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="flex items-center gap-4 my-5">
        <h1
          onClick={() => navigate("/activities")}
          className="text-lg font-bold capitalize cursor-pointer md:text-2xl text-primary"
        >
          {t("activities")}
        </h1>
        <FaChevronLeft className="ltr:rotate-180" />
        <p className="font-bold capitalize">{t("editActivity")}</p>
      </div>

      <article className="px-6 py-8 space-y-4 border border-white rounded-xl">
        <h1 className="my-4 text-lg font-bold capitalize md:text-2xl">
          {t("addEvent")}
        </h1>
        <TextInput formik={formik} label={t("activityName")} name={"name"} />
        <TextArea formik={formik} label={t("desc")} name={"desc"} />
        <TextInput number formik={formik} label={t("maxSeats")} name={"maxSeats"} />
        <div className="inputs">
          <Select
            options={memberShipTypeOptions}
            formik={formik}
            label={t("category")}
            name={"category"}
          />
          <Select
            options={memberShipTypeOptions}
            formik={formik}
            label={t("allowedCategory")}
            name={"allowedCategory"}
          />
        </div>
        <div className="inputs">
          <DateInput formik={formik} label={t("startDate")} name={"startDate"} />
          <TimeInput formik={formik} label={t("time")} name={"time"} />
        </div>
        <div className="inputs"></div>
        <FileInput formik={formik} name={"photos"} label={t("photos")} id={"photos"} />
        <div className="flex items-center justify-end gap-2">
          <Button className={"bg-primary flex justify-center text-black py-3"}>
            {t("save")}
          </Button>
          <Button
            onClick={() => {
              navigate("/activities");
            }}
            className={"border border-white text-white flex justify-center py-3"}
          >
            {t("cancel")}
          </Button>
        </div>
      </article>
    </form>
  );
};

export default EditActivity;
